import { updateUsersComments } from '../api/updateUsersComments';
import { setGetMailingUsers } from './setGetMailingUsers';

export const setUpdateUsersComments = (params, callback) => {
    return async (dispatch, getState) => {
        try {
            const { data } = await updateUsersComments(params);

            if (callback) {
                callback();
            }

            dispatch(setGetMailingUsers({
                id: params.mailing_id,
                page: 1,
                pageSize: 25
            }));
        } catch (error) {
            console.log(error)
            alert(error?.response?.data?.message)
            console.log(error)
        }
    }
}